import Vue from "vue";
import _ from 'lodash';
import { isEmpty } from 'lodash';
Object.defineProperty(Vue.prototype, '_', { value: _ });
var stageNames = ['espm-submitted', 'espm-head-review', 'hq-sales-review', 'sa-head-review', 'rsm-confirm', 'sales-director-confirm', 'gro-head-confirm', 'sa-head-confirm', 'hq-sales-confirm', 'espm-kick-off'];



var build_updated_item_temp = function (request_data) {
  console.log("DO:build_updated_item_temp");
  let result = {
    action: request_data.action,
    currency: request_data.currency,
    customization_description: request_data.add_quote.customization_description,
    description: request_data.add_quote.sku_description,
    ftie_id: request_data.ftie_id,
    gro_cost: null,
    hq_cost: request_data.hq_cost,
    nre_id: request_data.nre_id,
    qty: request_data.add_quote.qty,
    quote_type: request_data.add_quote.quote_type,
    real_sku_no: request_data.real_sku_no,
    sales_force_opty: request_data.sales_force_opty,
    selling_price: null,
    sku_description: request_data.add_quote.sku_description,
    sku_id: request_data.sku_id,
    uni_id: request_data.uni_id,
    //amortize_qty: request_data.amortize_qty, //NEW
    //create_function: request_data.create_function, //NEW
  }
  return result;
};



var build_quote_after_edit = function (quotes, updated_quote){
  console.log("DO:build_quote_after_edit with uni_id ==");
  console.log(updated_quote.uni_id);
  if (quotes && quotes.length > 0) {
    var index = _.findIndex(quotes, { uni_id: updated_quote.uni_id });
    if (index != null && index >= 0 && index < quotes.length) {
      // Replace item at index using native splice
      quotes.splice(index, 1, updated_quote);
    }
  }
  return quotes;
};

var build_quote_after_delete = function (quotes, delete_uni_id){
  console.log("build_quote_after_delete with delete_uni_id ==");
  console.log(delete_uni_id);
  if (quotes && quotes.length > 0) {
    quotes = _.reject(quotes, ['uni_id', delete_uni_id]);
  }
  return quotes;
};




Vue.filter("updateQuoteList", function (stageIndex, quotes, updated_uni_id, updated_quote, action) {
  console.log("updateQuoteList for stage:");
  console.log(stageNames[stageIndex]);
  let result = quotes;

  if ('modified' == action) {
    result = build_quote_after_edit(quotes, updated_quote);
  }
  
  else if ('delete' == action) {
    result = build_quote_after_delete(quotes, updated_uni_id);
  }

  else if ('add' == action) {
    if (updated_uni_id != null && updated_uni_id != '') {
      result.push(updated_quote);
    }
    else {
      let quote_append_defult = build_updated_item_temp(updated_quote);
      result.push(JSON.parse(JSON.stringify(quote_append_defult)));
    }
  }

  return result;
});



// WEBPACK FOOTER //
// ./src/helpers/quote-setter.js